import LegalLayout from "@/components/legal/LegalLayout";
import Seo from "@/components/Seo";
import { LEGAL_NAME, SUPPORT_EMAIL, TRADING_NAME } from "@/constants/company";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service"
        description={`Terms governing your use of the ${TRADING_NAME} solar assessment platform and services.`}
        path="/terms"
      />
      <LegalLayout title="Terms of Service" subtitle="Last updated: January 2025">
      <section className="space-y-8 not-prose">
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">1. Agreement to Terms</h2>
          <p className="mb-3 text-base leading-relaxed text-[#2A2A33]">
            These Terms of Service (&quot;Terms&quot;) govern your access to and use of the {TRADING_NAME} platform, website,
            and services provided by {LEGAL_NAME} (&quot;{TRADING_NAME}&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;),
            a company registered in England and Wales.
          </p>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            By accessing or using our Services, you agree to be bound by these Terms.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">2. Use of Services</h2>
          <p className="mb-3 text-base leading-relaxed text-[#2A2A33]">
            You must be at least 18 years old to use our Services. You agree to provide accurate information
            and keep your account credentials secure.
          </p>
          <p className="mb-2 text-base leading-relaxed text-[#2A2A33]">You may not:</p>
          <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>Violate applicable laws or regulations</li>
            <li>Infringe intellectual property rights</li>
            <li>Transmit harmful code or attempt unauthorised access</li>
            <li>Use automated tools without permission</li>
          </ul>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">3. Solar Assessments and Quotes</h2>
          <p className="mb-3 text-base leading-relaxed text-[#2A2A33]">
            {TRADING_NAME} provides automated solar assessments based on property data, satellite imagery, and energy usage
            estimates. These are estimates only — final quotes are provided by installer partners after a site survey.
          </p>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            {TRADING_NAME} acts as a platform connecting homeowners with MCS-certified installers. We do not directly install
            solar systems. Any installation contract is between you and the installer.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">4. Payment and Fees</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            Use of the {TRADING_NAME} platform for solar assessments and quotes is currently free for homeowners.
            Payments for installation services are made directly to the installer according to their terms.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">5. Limitation of Liability</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            To the fullest extent permitted by law, {TRADING_NAME} shall not be liable for any indirect, incidental,
            special, or consequential damages arising from your use of the Services.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">6. Contact</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            Questions about these Terms:{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-indigo hover:underline">{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </section>
    </LegalLayout>
    </>
  );
}
